export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-thumbnail-v1-960-34977d68f55b4d5bc3c8c801f8be08a3.webp";